import React from 'react';

import { AddToastMessage } from '../api/types';


const AppContext = React.createContext(
  {
    setPanelContent: (
      renderPanelContent?: () => React.ReactNode
    ) => {},
    useToasts: {
      addToast: (
        message: AddToastMessage | string,
        type: 'primary' | 'danger' | 'warning' | 'success',
        autoClose?: boolean
      ) => {}
    }
  },
);

export default AppContext;
